import React, { useState } from "react";
import { Link } from "react-router-dom";
import {useLogin} from '../hooks/useLogin';
import axios from 'axios';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [resetCodeError, setResetCodeError] = useState('');
    const {login, error, isLoading} = useLogin();


    const handleSubmit = async (e) => {
        e.preventDefault()

        //login function comes from useLogin hook that was created
        await login(email, password);
    }


    const handleReset = async (e) => {
        if(email) {
            //send reset code
            try {
                const resetResponse = await axios.post(
                    process.env.REACT_APP_SERVER_URL + '/api/user/reset-code', 
                    { email }
                );
                //send user to reset password page
                if(resetResponse.data.url){
                    window.location.href = resetResponse.data.url;
                }
            } catch (e) {
                setResetCodeError(e.response.data.error);
                console.log('Reset Code Error - ' + e.response.data.error)
            }
        } else {
            setResetCodeError('Please enter an email');
        }
    }



    return (
        <form className="login" onSubmit={handleSubmit}>
            <h3>Log In</h3>
            <div className="inner-auth-form-container">
                <label>Email</label>
                <input 
                    type="text"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Password</label>
                <input 
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                />
            </div>
            <div className="login-links">
                <span onClick={handleReset}>Reset Password</span>
                <Link to='/signup'>Don't have an account?</Link>
            </div>
            <button type="submit" className="btn btn-light" disabled={isLoading}>Log In</button>
            {error && <div className="error">{error}</div> }
            {resetCodeError && <div className="error">{resetCodeError}</div> }
        </form>
    )
}

export default Login;